import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="company_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) return;

    const email = (form.querySelector('[name="email"]') as HTMLInputElement)?.value;
    if (!email) return;

    const formData = new URLSearchParams();
    formData.append('email', email);

    fetch('https://readdy.ai/api/form/d8ukcqb9akq3s3asoa30', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    })
      .then(() => {
        (form.querySelector('[name="email"]') as HTMLInputElement).value = '';
        const statusEl = form.querySelector('.subscribe-status');
        if (statusEl) {
          statusEl.textContent = 'Subscribed! Thank you.';
          setTimeout(() => { statusEl.textContent = ''; }, 3000);
        }
      })
      .catch(() => {
        const statusEl = form.querySelector('.subscribe-status');
        if (statusEl) {
          statusEl.textContent = 'Something went wrong. Try again.';
          setTimeout(() => { statusEl.textContent = ''; }, 3000);
        }
      });
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <h3 className="text-2xl font-heading font-bold text-foreground-950 leading-tight">
              AllChinaBuy<br />Spreadsheet
            </h3>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              Your trusted hub for China product spreadsheets and sourcing guides.
            </p>
            <div className="mt-10">
              <p className="text-xs font-medium text-foreground-500 mb-3 uppercase tracking-wider">
                Subscribe for updates
              </p>
              <form data-readdy-form="true" onSubmit={handleSubmit} className="flex flex-col gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="w-full max-w-xs bg-transparent border-b border-foreground-300 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                />
                <input
                  type="text"
                  name="company_alt"
                  autoComplete="off"
                  tabIndex={-1}
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="w-fit px-6 py-2.5 border border-foreground-300 text-sm font-medium text-foreground-700 rounded-full hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Join
                </button>
                <span className="subscribe-status text-xs text-secondary-600 mt-1"></span>
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Shop</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Guides</h4>
              <ul className="space-y-2.5">
                <li><Link to="/allchinabuy-sheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Shopping Guide</Link></li>
                <li><Link to="/allchinabuy-sheet-safety" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Safety &amp; Trust</Link></li>
                <li><Link to="/allchinabuy-sheet-vs-competitors" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Competitor Comparison</Link></li>
                <li><Link to="/allchinabuy-sheet-pricing" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Pricing Strategy</Link></li>
                <li><Link to="/allchinabuy-sheet-beginners" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Beginner's Guide</Link></li>
                <li><Link to="/allchinabuy-sheet-shipping" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Shipping &amp; Logistics</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">More</h4>
              <ul className="space-y-2.5">
                <li><Link to="/allchinabuy-sheet-trending" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Trending Products</Link></li>
                <li><Link to="/allchinabuy-sheet-wholesale" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Wholesale Buying</Link></li>
                <li><Link to="/allchinabuy-sheet-quality" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Quality Control</Link></li>
                <li><Link to="/allchinabuy-sheet-updates" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Daily Updates</Link></li>
                <li><Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Home</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} AllChinaBuySpreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            China Product Research Team — Updated Daily
          </p>
        </div>
      </div>
    </footer>
  );
}